import React, { useEffect } from "react";
import { useCaptcha } from "@repoflow/components/captcha";
import * as CaptchaLib from "@repoflow/browser/captcha";
import { Icon as LoadingIcon } from "@repoflow/components/loading";
import * as ParamsLib from "@repoflow/browser/params";
import * as Loading from "@repoflow/components/loading";

import { useMutation, gql } from "@apollo/client";
import { Container, Col, Row, Alert } from "reactstrap";
import { basename } from "env";

const MUTATION = gql`
  mutation Callback($authorization: String!, $token: String!) {
    viewer {
      anonymous(token: $token) {
        auth {
          callback(authorization: $authorization) {
            user {
              id
              email
              status
              domain
              orgId
              roles
            }
          }
        }
      }
    }
  }
`;

export default () => {
  const authorization = ParamsLib.urlParameter("token");
  const { publicKey, ready } = useCaptcha();

  const [handler, { error: mutationError }] =
    useMutation(MUTATION, {
      refetchQueries: [],
      onCompleted: (data) => {
        const account = data.viewer.anonymous.auth.callback
        if (account) {
          window.location = `${basename}`;
        }
      },
      onError: (error) => {
        console.error("auth.callback:", error);
      },
    });

  useEffect(() => {
    if (ready) {
      CaptchaLib.request(publicKey, (token) => {
        handler({
          variables: {
            authorization,
            token,
          },
        });
      });
    }
  }, [ready]);

  if (!ready) {
    return <Loading.Content />;
  }

  return (
    <Container>
      <Row className="mt-4">
        <Col>
          {!mutationError ? (
            <Alert color="info">
              Signing you in... <LoadingIcon />
            </Alert>
          ) : (
            <Alert color="danger">
              We could not complete your sign in. Please try again or contact
              support.
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
};